import SpacePath from "components/SpacePath";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableSpaceCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  if (row.kind === "public") {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellEmpty />
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps}>
      <SpacePath
        spaceId={row.workerPool.spaceDetails.id}
        fallbackName={row.workerPool.spaceDetails.name}
      />
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableSpaceCell;
